import { RegainsResponseItem } from "api/models";

export enum RegainStatus {
  DEFAULT = "default",
  REPORTED = "reported",
  ACCEPTED = "accepted"
}

export type RegainWithStatus = RegainsResponseItem & {
  status: RegainStatus;
};
